// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2374":"47c6824515f4ea94","3877":"fe336940f98fdfab","6272":"aa4472f7082b94cd","6355":"e25c054d41e77a47"}[chunkId] + ".css";
};